import { Inject, Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders } from "@angular/common/http";
import { from, Observable } from "rxjs";
import { switchMap, timeout } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { UserInfoService } from "./userinfo.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly REQUEST_TIMEOUT = 120000;

  constructor(
    private auth: AuthService,
    private userInfo: UserInfoService,
    @Inject("BASE_URL") private readonly baseUrl: string
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.getHeaders(req.url, req.headers)).pipe(switchMap((headers: HttpHeaders | null) => {
      if (headers) {
        const clone = req.clone({ headers });
        return next.handle(clone).pipe(timeout(this.REQUEST_TIMEOUT));
      } else {
        return next.handle(req).pipe(timeout(this.REQUEST_TIMEOUT));
      }
    }));
  }

  private async getHeaders(url: string, requestHeaders: HttpHeaders): Promise<HttpHeaders> {
    if (this.isBffEnrolledUrl(url)) {
      let bffHeaders = await this.getBffHeaders();

      if (requestHeaders.has("Accept-Language")) {
        const value = requestHeaders.get("Accept-Language");
        bffHeaders = bffHeaders.set("Accept-Language", value);
      }

      if (requestHeaders.has("NAA-Authorization")) {
        const value = requestHeaders.get("NAA-Authorization");
        bffHeaders = bffHeaders.set("NAA-Authorization", value);
      }

      if (requestHeaders.has("X-Shared-Mailbox")) {
        const value = requestHeaders.get("X-Shared-Mailbox");
        bffHeaders = bffHeaders.set("X-Shared-Mailbox", value);
      }

      return bffHeaders;
    } else {
      return null;
    }
  }

  async getBffHeaders(): Promise<HttpHeaders> {
    await this.auth.ensureHasClientAppSession();
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: `Bearer ${this.userInfo.clientAppBearer}`
    });
    return headers;
  }

  isBffEnrolledUrl(url: string): boolean {
    return this.baseUrl !== ""
      && url.startsWith(this.baseUrl)
      && !url.endsWith("/api/auth/login")
      && !url.endsWith("/api/configSettings");
  }
}
